import { render } from "./Prop.vue?vue&type=template&id=30df78f5&scoped=true"
import script from "./Prop.vue?vue&type=script&lang=js"
export * from "./Prop.vue?vue&type=script&lang=js"

import "./Prop.vue?vue&type=style&index=0&id=30df78f5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lrive\\source\\repos\\XOneFrameworkWEB\\XOneWebVue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30df78f5"]])

export default __exports__